import { JwtAxios } from '@/packaging';

export const aiApi = {
  /**
   * 상품 정보 자동 생성 (이미지 기반)
   * @param {FormData} formData - productName, image, model
   */
  async generateProductInfo(formData) {
    const responseModel = await JwtAxios.post('/AI/GenerateProductInfo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return responseModel;
  },

  /**
   * 상세페이지 자동 생성
   * @param {FormData} formData - images, pageType, productName, productInfo, noTextMode, complexProductMode, engineSpeed, model
   */
  async generateDetailPage(formData) {
    const responseModel = await JwtAxios.post('/AI/GenerateDetailPage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 120000 // 2분 타임아웃 (AI 생성에 시간이 걸릴 수 있음)
    });
    return responseModel;
  },

  /**
   * 상품 이미지 자동 생성 (썸네일 5장 + 상세페이지)
   * @param {FormData} formData - images, productName, keywords, targetCustomer, productInfo, template, model 등
   */
  async generateProductImages(formData) {
    const responseModel = await JwtAxios.post('/AI/GenerateProductImages', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 300000 // 5분 타임아웃 (이미지 6장 생성에 시간이 걸림)
    });
    return responseModel;
  },

  /**
   * 외부 이미지 URL을 Base64로 변환 (프록시)
   * @param {string} imageUrl - 이미지 URL
   */
  async proxyImage(imageUrl) {
    const responseModel = await JwtAxios.post('/AI/ProxyImage', { imageUrl });
    return responseModel;
  },

  /**
   * AI 생성 결과 상품에 저장
   * @param {Object} data - productId, productName, keywords, thumbnails, detailImages 등
   */
  async saveAiResult(data) {
    const responseModel = await JwtAxios.post('/AI/SaveAiResult', data);
    return responseModel;
  },

  /**
   * AI 상품명 변경
   * @param {Object} data - productIds(배열), promptTemplateIdx(프롬프트 템플릿 인덱스)
   */
  async ChangeProductTitle(data) {
    const responseModel = await JwtAxios.post('/AI/ChangeProductTitle', data, {
      timeout: 300000 // 5분 타임아웃 (여러 상품 처리 시 시간 소요)
    });
    return responseModel;
  },

  /**
   * AI 상품명 복구 (원본으로 복구)
   * @param {Object} data - productIds(배열)
   */
  async RestoreProductTitle(data) {
    const responseModel = await JwtAxios.post('/AI/RestoreProductTitle', data);
    return responseModel;
  },

  /**
   * AI 상세페이지 프리셋 목록 조회
   */
  async getDetailPresets() {
    const responseModel = await JwtAxios.get('/AI/GetDetailPresets');
    return responseModel;
  },

  /**
   * AI 상세페이지 프리셋 저장
   * @param {Object} data - presetName, detailPageSlots, imageSize, template 등
   */
  async saveDetailPreset(data) {
    const responseModel = await JwtAxios.post('/AI/SaveDetailPreset', data);
    return responseModel;
  },

  /**
   * AI 상세페이지 프리셋 삭제
   * @param {number} idx - 프리셋 인덱스
   */
  async deleteDetailPreset(idx) {
    const responseModel = await JwtAxios.post('/AI/DeleteDetailPreset', { idx });
    return responseModel;
  },

  /**
   * AI 상세페이지 슬롯별 컨텐츠 생성
   * @param {FormData} formData - slotType, productName, keywords, 참고 이미지 등
   */
  async generateSlotContent(formData) {
    const responseModel = await JwtAxios.post('/AI/GenerateSlotContent', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 180000 // 3분 타임아웃
    });
    return responseModel;
  }
};
